export default state => {
  return state.limit
}



// WEBPACK FOOTER //
// ./src/store/modules/contact_forms/getters/contactFormLimit.js